import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StayConnected = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/subscription/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success(data.message || 'Subscribed successfully!');
        setEmail('');
      } else {
        toast.error(data.message || 'Subscription failed.');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#E8E8E8] py-20 px-4">
      <div className="max-w-3xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-light text-black mb-10" style={{ fontFamily: "'Playfair Display', serif" }}>
          Stay Connected
        </h2>

        {/* Subheading */}
        <p className="mt-2 text-gray-600 text-lg">
          Join the Elixir Community
        </p>

        {/* Description */}
        <p className="mt-6 text-base text-gray-700">
          Stay informed about new varieties, exclusive offers, and the latest news from Elixir.
        </p>

        {/* Form */}
        <form className="mt-8 flex flex-col md:flex-row items-center justify-center gap-4" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email address*"
            className="w-full md:w-2/3 px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <button
            type="submit"
            className="w-full md:w-auto px-6 py-3 bg-[#D4AF37] text-black rounded-md hover:bg-[#c39c2b] transition-colors duration-300"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default StayConnected;
